import { render, staticRenderFns } from "./CategoryModal.vue?vue&type=template&id=db4d9d52&scoped=true"
import script from "./CategoryModal.vue?vue&type=script&lang=ts"
export * from "./CategoryModal.vue?vue&type=script&lang=ts"
import style0 from "./CategoryModal.vue?vue&type=style&index=0&id=db4d9d52&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db4d9d52",
  null
  
)

export default component.exports